module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/5/4-e03f97ee85504c40c9f0b4a8803e4b2d.jpg";